import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row justify-content-center h-100" }
const _hoisted_2 = { class: "col-9 h-100 d-flex flex-column py-5" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "row justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
    /*#__PURE__*/_createElementVNode("h5", { class: "fw-bold text-center mb-5 mt-4" }, "Verify email")
  ])
], -1)
const _hoisted_4 = { class: "text-center mb-5" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: "/images/mobile-icon.png",
  class: "mb-5",
  width: "70"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h6", { class: "text-primary text-uppercase fw-bold" }, "Enter the 6-digit OTP code", -1)
const _hoisted_7 = { class: "text-muted fw-bold" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h6", { class: "text-success text-uppercase fw-bold" }, "Success", -1)
const _hoisted_9 = { class: "text-muted fw-bold" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h6", { class: "text-danger text-uppercase fw-bold" }, "Incorrect code", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "text-muted fw-bold" }, "Try Entering the OTP Code again", -1)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = { class: "otp-container" }
const _hoisted_14 = { class: "d-flex flex-row justify-content-center" }
const _hoisted_15 = { class: "text-center mt-auto" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h6", { class: "text-center fw-bold text-muted" }, "Didn't receive email?", -1)
const _hoisted_17 = { class: "text-center fw-bold text-muted" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" or ")
const _hoisted_19 = /*#__PURE__*/_createElementVNode("a", {
  class: "fw-bold text-primary",
  href: "/signup"
}, "Change Email", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_otp_input = _resolveComponent("v-otp-input")!
  const _component_pre_loader = _resolveComponent("pre-loader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.onSuccess || _ctx.onError ? 'd-none' : '')
          }, [
            _hoisted_6,
            _createElementVNode("p", _hoisted_7, "We’ve sent it to " + _toDisplayString(_ctx.email), 1)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.onSuccess ? '' : 'd-none')
          }, [
            _hoisted_8,
            _createElementVNode("p", _hoisted_9, "We’ve sent it to " + _toDisplayString(_ctx.email), 1)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.onError ? '' : 'd-none')
          }, _hoisted_12, 2)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_v_otp_input, {
              ref: "otpInput",
              "input-classes": "otp-input small fw-bold",
              separator: " ",
              "num-inputs": 6,
              "should-auto-focus": true,
              "is-input-num": true,
              conditionalClass: ['one', 'two', 'three', 'four', 'five', 'six'],
              placeholder: ['', '', '', ''],
              onOnChange: _ctx.handleOnChange,
              onOnComplete: _ctx.handleOnComplete
            }, null, 8, ["onOnChange", "onOnComplete"])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("h6", _hoisted_17, [
            _createElementVNode("a", {
              class: "fw-bold text-primary",
              href: "#",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.resendOTP()), ["prevent"]))
            }, "Resent"),
            _hoisted_18,
            _hoisted_19
          ])
        ])
      ])
    ]),
    _createVNode(_component_pre_loader, {
      class: _normalizeClass(!_ctx.onLoad ? 'd-none': '')
    }, null, 8, ["class"])
  ], 64))
}